import { DotPulse } from "ldrs/react";
import "ldrs/react/DotPulse.css";

import React from "react";

type DotPulseLdrProps = {
  size?: number;
  speed?: number;
  color?: string;
  className?: string;
};

function DotPulseLdr({
  size = 43,
  speed = 1.3,
  color = "var(--color-slateCustom)",
  className,
}: DotPulseLdrProps) {
  return (
    <div className={className}>
      <DotPulse size={size} speed={speed} color={color} />
    </div>
  );
}

export default DotPulseLdr;
